import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'
import {createReservationNextStepAction as createReservationNextStepActionAPI} from '../../../services/reservations'
import fixture from '../../../fixtures/reservations/get-configuration.json'

export async function createReservationNextStepAction(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await createReservationNextStepActionAPI(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Create Reservation Next Step Action Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}

export async function resetReservationNextStepAction(dispatch) {
  dispatch({type: RESET})
}
